import { useTheme } from '@emotion/react'
import { gradient } from 'chaoskit/src/assets/styles/utility'
import { StylesContainerVariables } from 'chaoskit/src/components/Container'

import Hero from '~partials/Hero'

export const HomeHero = (props) => {
  const theme = useTheme()

  return (
    <Hero
      css={{
        ...gradient.dark(theme),
        overflow: 'hidden',
      }}
      {...props}
    />
  )
}

export const HomeHeroGrid = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        paddingLeft: theme.space.base,
        paddingRight: theme.space.base,
        maxWidth: StylesContainerVariables.base,
        display: 'grid',
        margin: '0 auto',
        gap: theme.space.base,
        alignItems: 'center',

        [theme.mq.medium]: {
          gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
          gap: 0,
          paddingTop: theme.space.large,
        },
      }}
      {...props}
    />
  )
}

export const HomeHeroGridImage = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        [theme.mq.medium]: {
          gridRow: 1,
          gridColumn: '7 / span 6',

          'img, svg': {
            maxWidth: 'none',
            height: 600,
          },
        },
      }}
      {...props}
    />
  )
}

export const HomeHeroGridContent = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        position: 'relative',
        zIndex: 1,

        [theme.mq.medium]: {
          gridRow: 1,
          gridColumn: '1 / span 6',
        },
      }}
      {...props}
    />
  )
}
